import { GoogleBusinessConnectionOptions } from '../../../../../modals/live-orders/LiveOrdersDrawer';

export default {
  title: 'Pós-Lançamento',
  subtitle: 'Veja os dados da checklist de Go Live e defina a data de triagem pós-lançamento.',
  go_live_checklist: {
    labels: {
      yes: 'Sim',
      no: 'Não',
    },
    title: 'Checklist de Go Live',
    form: {
      is_google_business_available: {
        label: 'Google Business disponível',
      },
      is_smart_pricing_configured: {
        label: 'Preços mais baixos que Lieferando, Wolt, Uber',
      },
      is_flyers_package_sent: {
        label: 'Flyer promocional enviado',
      },
      is_menu_fully_configured: {
        label: 'Todos os itens do menu disponíveis',
      },
      has_offers_on_competitor_platforms: {
        label: 'O restaurante tem promoções ativas no Wolt, Uber, Lieferando (exceto oferta de entrega gratuita)?',
      },
      is_instagram_story_shared: {
        label: 'Story do Instagram partilhado com o proprietário',
      },
      is_order_system_connected_to_website: {
        label: 'Website Foodamigos ligado OU botão de encomenda online no website próprio do restaurante adicionado',
      },
      google_business_connected_by: {
        label: 'Como obtivemos acesso ao Google Business Profile?',
        options: {
          [GoogleBusinessConnectionOptions.SalesManagerOverEmail]: 'Gestor de vendas convidou google@foodamigos.io',
          [GoogleBusinessConnectionOptions.SalesManagerOverPhone]:
            'Gestor de vendas enviou o primeiro pedido a partir do telemóvel do proprietário',
          [GoogleBusinessConnectionOptions.OnboardingManagerOverEmail]:
            'Gestor de onboarding solicitou o Google Business Profile (o GV não convidou nem solicitou acesso)',
          null: 'N/D',
        },
      },
    },
    buttons: {
      save: 'Guardar',
    },
    toasts: {
      success: 'Guardado com sucesso',
      error: 'Falha ao guardar',
    },
  },
  post_launch_screening: {
    title: 'Triagem Pós-Lançamento',
    form: {
      screening_date: {
        label: 'Data de Triagem',
      },
    },
    toasts: {
      success: 'Guardado com sucesso',
      error: 'Falha ao guardar',
    },
    buttons: {
      save: 'Guardar',
    },
  },
};
